<template>
  <div>
    <v-layout align-center>
      <v-flex xs12 sm10 md8 lg6>
        <v-layout wrap>
          <v-flex xs12>
            <div v-if="$apollo.loading">
              <spinner />
            </div>
            <div v-else>
              <div class="title-screen">
                <span>{{ adminText('workflowsAll.invite_attendees_9c2ffd6', 'Invite attendees') }}</span>
              </div>
              <v-select
                v-model="eventSlug"
                :items="workflowUi(performanceDates)"
                :label="adminText('workflowsAll.performance_63c9045', 'Performance')"
                item-text="from"
                item-value="slug"
                box
                @change="onPerformanceSelect"
              />
              <attendee-invite-form
                :key="eventSlug"
                :event-slug="eventSlug"
                :selected-language="selectedLanguage"
                :form="form"
                :invite-url="inviteUrl"
                @onSelectedLanguage="onLanguageChange"
                @onShowSnackbar="showSnackbar"
              />
            </div>
          </v-flex>
        </v-layout>
      </v-flex>
    </v-layout>
    <simple-snackbar
      :open.sync="snackbar.open"
      :message-prop="workflowLabel(snackbar.message)"
      :color="snackbar.color"
    />
  </div>
</template>

<script>
import WorkflowDisplay from '@/admin-i18n/workflows-all-display'
import Spinner from '../shared/spinner'
import AttendeeInviteForm from './attendee-invite-form.vue'
import { GET_EVENTS_BY_EVENT_TEMPLATE_ID } from '@/graphql/event.graphql'
import moment from 'moment'
import { frontendURL } from '@/utils'
import SimpleSnackbar from '@/components/shared/snackbars/simple-snackbar.vue'

export default {
  mixins: [WorkflowDisplay],
  name: 'theater-invite-attendees',
  components: {
    SimpleSnackbar,
    Spinner,
    AttendeeInviteForm,
  },
  props: {
    eventTemplateId: {
      default: null,
      type: String,
    },
    organizationSlug: String,
  },
  data() {
    return {
      selectedLanguage: 'en',
      performanceDates: [],
      form: {
        url: '',
      },
      eventSlug: null,
      snackbar: {},
    }
  },
  computed: {
    inviteUrl() {
      return this.form.url.length ? `${this.form.url}?lang=${this.selectedLanguage}` : ''
    },
  },
  methods: {
    onLanguageChange(language) {
      this.selectedLanguage = language
    },
    onPerformanceSelect() {
      this.form.url = this.generateInviteUrl()
    },
    generateInviteUrl() {
      return `${frontendURL}/events/${this.eventSlug}/register`
    },
    showSnackbar(snackbarData) {
      this.snackbar = snackbarData
    },
  },
  apollo: {
    getEventsByEventTemplateId: {
      query: GET_EVENTS_BY_EVENT_TEMPLATE_ID,
      variables() {
        return {
          organizationSlug: this.organizationSlug,
          eventTemplateId: this.eventTemplateId,
        }
      },
      result({ data: { getEventsByEventTemplateId } }) {
        this.performanceDates = getEventsByEventTemplateId
          .filter(p => moment(p.from).isAfter(moment().startOf('day')))
          .map(p => {
            return { ...p, from: moment(p.from).format('DD.MM.YYYY u HH:mm') }
          })
        this.eventSlug = this.performanceDates[0].slug || ''

        if (this.eventSlug !== '') {
          this.form.url = this.generateInviteUrl()
        }
      },
    },
  },
}
</script>

<style scoped>
.title-screen {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 2rem;
}

@media screen and (max-width: 800px) {
  .title-screen {
    display: none;
  }
}
</style>
